<template>
  <div class="webrtc-wrap" id="webrtcWrap">
    <select class="hidden-content" id="audiodevice"></select>
    <select class="hidden-content" id="videodevice"></select>
    <input class="hidden-content" id="roomtoken" type="text">
    <div id="controlArea" class="rtc-control">
      <input @click="ctrlClick1" type="button" id="mutei" class="volum">
      <input @click="ctrlClick2" type="button" id="micmutei" class="micvolum">
      <input @click="ctrlClick3" type="button" id="camerai" class="camera">
      <input @click="openQuite" type="button" id="quiteroom" class="quiteroom" :value="$t('message.结束面试')">
    </div>
    <div id="localvideo"></div>
    <div id="remotevideo"></div>
    <div id="window-tips" class="window-tips-bg">
      <div class="content">
        <img src="@/assets/interview/images/icon-inter-off.png" alt="">
        <!-- 要现在结束面试吗？ -->
        <h4>{{ $t('message.finish_interview') }}</h4>
        <div class="btn-area">
          <input @click="closeTips" id="closeTips" type="button" :value="$t('message.取消')">
          <input @click="closeVideo" id="closeVideo" type="button" :value="$t('message.结束')">
        </div>
      </div>
    </div>
    <div id="loading-area">
      <img src="@/assets/interview/images/icon-vcr.png" alt="">
      <span id="tipsText">{{ $t('message.视频通讯中') }}...</span>
    </div>
    <div id="countdown">{{ $t('message.面试已进行') }}：{{ interviewTime }}</div>
  </div>
</template>

<script>
import '@/assets/css/index.css';
import * as QNRTC from 'pili-rtc-web';
import { mapGetters } from 'vuex';

export default {
  components: {

  },

  data() {
    return {
      inter_id: '',
      myRoom: new QNRTC.StreamModeSession(),
      timeinter: null,
      yourRoom: '',
      lock1: false,
      lock2: false,
      lock3: false,
      rtckey: '',
      timestamp: 0,
      interviewTime: '00：00：00',
      way: 1,
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  methods: {
    // 获取页面数据
    getPageData: function(interid) {
      this.$http._post({
        url: '/interview/Plan/roomKey',
        data: { id: interid }
      }).then(({ data }) => {
        this.rtckey = data.room_key;
        this.timestamp = 0;
        this.interviewTime = this.formatDuring(parseInt(this.timestamp * 1000, 0));
        this.joinRoom();
      });
    },
    subscribeUser: function(userId) {
      // 订阅目标用户
      this.myRoom.subscribe(userId).then((stream) => {
        this.yourRoom = stream;
        stream.play(document.getElementById('remotevideo'), false);
        this.showroom();
        this.timecount();
      });
    },
    getExplorerInfo: function() {
      let explorer = navigator.userAgent.toLowerCase();
      if (explorer.indexOf('msie') >= 0) {
        let ver = explorer.match(/msie ([\d.]+)/)[1];
        return { type: 'IE', version: ver };
      } else if (explorer.indexOf('firefox') >= 0) {
        let ver = explorer.match(/firefox\/([\d.]+)/)[1];
        return { type: 'Firefox', version: ver };
      } else if (explorer.indexOf('chrome') >= 0) {
        let ver = explorer.match(/chrome\/([\d.]+)/)[1];
        return { type: 'Chrome', version: ver };
      } else if (explorer.indexOf('opera') >= 0) {
        let ver = explorer.match(/opera.([\d.]+)/)[1];
        return { type: 'Opera', version: ver };
      } else if (explorer.indexOf('Safari') >= 0) {
        let ver = explorer.match(/version\/([\d.]+)/)[1];
        return { type: 'Safari', version: ver };
      }
    },
    unroom: function() {
      window.clearInterval(this.timeinter);
      document.getElementById('remotevideo').style.background = '#d8d8d8';
      document.getElementById('loading-area').classList.add('active');
      document.getElementById('controlArea').classList.add('active');
      document.getElementById('tipsText').innerHTML = `${this.$t('接続中')}...`;
    },
    showroom: function() {
      document.getElementById('remotevideo').style.background = '#000';
      document.getElementById('loading-area').classList.remove('active');
      document.getElementById('controlArea').classList.remove('active');
      this.isAudio();
    },
    // 时间计算
    formatDuring: function(mss) {
      let hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60), 0);
      let minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60), 0);
      let seconds = (mss % (1000 * 60)) / 1000;
      hours = hours < 10 ? `0${hours}` : hours;
      minutes = minutes < 10 ? `0${minutes}` : minutes;
      seconds = seconds < 10 ? `0${seconds}` : seconds;
      return `${hours}：${minutes}：${seconds}`;
    },
    addDeviceToSelect: function(deviceInfo) {
      // 清空之前 select 下的元素，重新遍历添加
      while (document.getElementById('audiodevice').firstChild) {
        document.getElementById('audiodevice').removeChild(document.getElementById('audiodevice').firstChild);
      }
      while (document.getElementById('videodevice').firstChild) {
        document.getElementById('videodevice').removeChild(document.getElementById('videodevice').firstChild);
      }
      // 遍历每个设备，添加到页面上供用户选择
      deviceInfo.forEach((info) => {
        const optionElement = document.createElement('option');
        optionElement.value = info.deviceId;
        optionElement.text = info.label;
        if (info.kind === 'audioinput') {
          document.getElementById('audiodevice').appendChild(optionElement);
        } else if (info.kind === 'videoinput') {
          document.getElementById('videodevice').appendChild(optionElement);
        }
      });
    },
    async quiteRoom() {
      let newdata = {
        userId: this.userInfo.userid,
        crm_id: '',
        platform: 5,
        body: {
          msgCode: 1000,
          txt: 'end_interview'
        },
        ext: {
          interviewId: this.inter_id,
          device: `${this.getExplorerInfo().type},${this.getExplorerInfo().version}`,
        }
      };
      let senddata = JSON.stringify(newdata);
      let that = this;
      that.$ws.send(senddata);
      this.myRoom.leaveRoom();
      this.unroom();
      document.getElementById('tipsText').innerHTML = '您已退出房间';
      await this.$http._post({
        url: '/interview/plan/finishInterview',
        data: { id: this.inter_id },
      });
      window.setTimeout(() => {
        window.close();
      }, 500);
    },
    async joinRoom() {
      // 从输入框中获取 roomToken
      const roomToken = this.rtckey;
      try {
        // 加入房间
        const users = await this.myRoom.joinRoomWithToken(roomToken);
        // 因为我们假设是一对一连麦，如果加入后发现房间人数超过就退出报错
        // 实际上这里更好的做法是在 portal 上连麦应用中配置好房间人数上限
        // 这样就不要在前端做检查了
        if (users.length > 2) {
          this.myRoom.leaveRoom();
          this.$message.error('当前房间人数已满。');
          return;
        }
        let newdata = {
          userId: this.userInfo.userid,
          crm_id: '',
          platform: 5,
          body: {
            msgCode: 1000,
            txt: 'start_interview'
          },
          ext: {
            interviewId: this.inter_id,
            device: `${this.getExplorerInfo().type},${this.getExplorerInfo().version}`,
          }
        };
        let senddata = JSON.stringify(newdata);
        setTimeout(() => {
          this.$ws.send(senddata);
        }, 1500);
        // 如果加入房间后发现房间已经有人发布，就订阅他
        users.forEach((item) => {
          if (item.userId !== this.myRoom.userId) {
            let videolock = false;
            if (this.way && Number(this.way) === 2) {
              videolock = true;
              document.getElementById('remotevideo').classList.add('ishidden');
            }
            this.myRoom.setMergeStreamLayout(this.myRoom.userId, {
              x: 930, y: 370, w: 350, h: 350, z: 1, hidden: videolock, muted: false,
            });
            this.subscribeUser(item.userId);
          } else {
            window.clearInterval(this.timeinter);
            document.getElementById('webrtcWrap').style.background = '#d8d8d8';
            document.getElementById('loading-area').classList.add('active');
            document.getElementById('tipsText').innerHTML = `${this.$t('接続中')}...`;
          }
        });
      } catch (e) {
        console.error(e);
        console.log(`加入房间失败！ErrorCode: ${e.code || ''}`);
        this.$message.error('加入房间失败，请检查网络。');
        return;
      }

      // 监听房间中其他人发布的事件，自动订阅他
      this.myRoom.on('user-publish', (user) => {
        this.subscribeUser(user.userId);
        let videolock = false;
        if (this.way && Number(this.way) === 2) {
          videolock = true;
          document.getElementById('remotevideo').classList.add('ishidden');
        }
        this.myRoom.setMergeStreamLayout(this.myRoom.userId, {
          x: 930, y: 370, w: 350, h: 350, z: 1, hidden: videolock, muted: false,
        });
      });
      // eslint-disable-next-line no-unused-vars
      this.myRoom.on('user-leave', (user) => {
        window.clearInterval(this.timeinter);
        document.getElementById('remotevideo').style.background = '#d8d8d8';
        document.getElementById('webrtcWrap').style.background = '#d8d8d8';
        document.getElementById('loading-area').classList.add('active');
        document.getElementById('tipsText').innerHTML = `${this.$t('接続中')}...`;
      });
      // 自动发布
      await this.publish();
    },
    async publish() {
      let stream;
      let isAudio = true;
      if (this.way && parseInt(this.way, 0) === 2) {
        isAudio = false;
      }
      try {
        // 通过用户在页面上指定的设备发起采集
        // 也可以不指定设备，这样会由浏览器自动选择
        stream = await QNRTC.deviceManager.getLocalStream({
          video: {
            enabled: isAudio,
            bitrate: 1000,
          },
          audio: {
            enabled: true,
            echoCancellation: true,
            noiseSuppression: true,
          },
        });
      } catch (e) {
        console.error(e);
        console.log(`采集失败，请检查您的设备。ErrorCode: ${e.code}`);
        this.$message.error('采集失败，请检查您的设备。');
        return;
      }

      // 将采集到的流静音播放
      stream.play(document.getElementById('localvideo'), true);

      try {
        // 发布采集流
        await this.myRoom.publish(stream);
      } catch (e) {
        console.error(e);
        console.log(`发布失败，ErrorCode: ${e.code}`);
        this.$message.error('发布失败，请检查网络。');
      }
    },
    openQuite: function() {
      document.getElementById('window-tips').classList.add('active');
    },
    closeVideo: function() {
      this.quiteRoom();
      document.getElementById('window-tips').classList.remove('active');
    },
    closeTips: function() {
      document.getElementById('window-tips').classList.remove('active');
    },
    ctrlClick1: function() {
      if (this.lock1) {
        this.yourRoom.audio.volume = 1;
        this.lock1 = false;
        document.getElementById('mutei').classList.remove('isfail');
      } else {
        this.yourRoom.audio.volume = 0;
        this.lock1 = true;
        document.getElementById('mutei').classList.add('isfail');
      }
    },
    ctrlClick2: function() {
      if (this.lock2) {
        this.myRoom.mute(false, this.lock3);
        this.lock2 = false;
        document.getElementById('micmutei').classList.remove('isfail');
      } else {
        this.myRoom.mute(true, this.lock3);
        this.lock2 = true;
        document.getElementById('micmutei').classList.add('isfail');
      }
    },
    ctrlClick3: function() {
      if (this.lock3) {
        this.myRoom.mute(this.lock2, false);
        this.lock3 = false;
        document.getElementById('camerai').classList.remove('isfail');
      } else {
        this.myRoom.mute(this.lock2, true);
        this.lock3 = true;
        document.getElementById('camerai').classList.add('isfail');
      }
    },
    isAudio: function() {
      let way = this.$route.params.way;
      console.log(way);
      if (way && parseInt(way, 0) === 2) {
        document.getElementById('webrtcWrap').style.background = '#111433';
        document.getElementById('loading-area').classList.add('active');
        document.getElementById('camerai').classList.add('ishidden');
        document.getElementById('remotevideo').classList.add('ishidden');
        document.getElementById('localvideo').classList.add('ishidden');
        document.getElementById('tipsText').innerHTML = '语音面试中...';
      } else {
        document.getElementById('localvideo').classList.remove('ishidden');
      }
    },
    timecount: function() {
      this.timeinter = window.setInterval(() => {
        this.timestamp += 1;
        this.interviewTime = this.formatDuring(parseInt(this.timestamp * 1000, 0));
      }, 1000);
    }
  },
  mounted() {
    this.inter_id = this.$route.params.inter_id;
    this.getPageData(this.$route.params.inter_id);

    if (QNRTC.deviceManager.deviceInfo) {
      this.addDeviceToSelect(QNRTC.deviceManager.deviceInfo);
    }
    QNRTC.deviceManager.on('device-update', (deviceInfo) => {
      this.addDeviceToSelect(deviceInfo);
    });
    let way = this.$route.params.way;
    this.way = way;
    if (way && parseInt(way, 0) === 2) {
      document.getElementById('localvideo').classList.add('ishidden');
    }
  },
  destroyed() {
    window.clearInterval(this.timeinter);
  },
};
</script>

<style scoped>
  html,body{
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    font-size: 12px
  }
  .webrtc-wrap{
    width: 100%;
    height:100vh;
  }
  .hidden-content{
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: -1;
    opacity: 0;
    pointer-events: none;
  }
  #localvideo{
    position: fixed;
    top: 10px;
    right: 10px;
    width: 300px;
    height: 225px;
    border-radius: 10px;
    background: #fff;
    overflow: hidden
  }
  #remotevideo{
    width: 100%;
    height: 100%;
    background: #000
  }
  #remotevideo.ishidden,#localvideo.ishidden{
    z-index: -1;
    opacity:0;
  }
  .rtc-control{
    display: block;
    position: fixed;
    left: 2%;
    bottom: 20px;
    width: 96%;
    background: #fff;
    border-radius: 10px;
    height: 60px;
    line-height: 60px;
    padding-left: 20px;
    z-index: 11;
  }
  .rtc-control.active{
    display: none
  }
  .rtc-control input{
    float: left;
    display: inline-block;
    cursor: pointer;
    outline: none;
    width: 26px;
    height: 26px;
    background: none;
    border: none;
    margin-right: 20px;
    margin-top: 17px;
  }
  .rtc-control input.volum{
    background: url(../../assets/interview/images/icon-audio-on.png) no-repeat center;
  }
  .rtc-control input.volum.isfail{
    background: url(../../assets/interview/images/icon-audio-off.png) no-repeat center;
  }
  .rtc-control input.micvolum{
    background: url(../../assets/interview/images/icon-mic-on.png) no-repeat center;
  }
  .rtc-control input.micvolum.isfail{
    background: url(../../assets/interview/images/icon-mic-off.png) no-repeat center;
  }
  .rtc-control input.camera{
    background: url(../../assets/interview/images/icon-camera-on.png) no-repeat center;
  }
  .rtc-control input.camera.isfail{
    background: url(../../assets/interview/images/icon-camera-off.png) no-repeat center;
  }
  .rtc-control input.camera.ishidden{
    display: none;
  }
  .rtc-control input:hover{
    opacity: .9
  }
  .rtc-control input.quiteroom{
    float: right;
    width: 130px;
    height: 40px;
    line-height: 40px;
    color: #fff;
    border-radius: 5px;
    margin-right: 10px;
    margin-top: 10px;
    font-size: 16px;
    text-align: center;
    background: #F6120F url(../../assets/interview/images/icon-video-off.png) no-repeat 20px center;
    padding-left: 33px;
  }
  .window-tips-bg{
    position: fixed;
    z-index: 15;
    top: 0;
    left: 0;
    height: 0;
    width: 100%;
    background: rgba(0,0,0,.7);
    opacity: 0;
    overflow: hidden;
    pointer-events: none;
    transition: all linear 0.3s
  }
  .window-tips-bg.active{
    height: 100%;
    opacity: 1;
    pointer-events: auto
  }
  .window-tips-bg .content{
    background: #fff;
    padding: 20px;
    border-radius: 10px;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%)
  }
  .window-tips-bg .content img{
    display: block;
    margin: 15px auto 0
  }
  .window-tips-bg .content h4{
    font-weight: normal;
    font-size: 16px;
    padding: 10px 0
  }
  .window-tips-bg .content .btn-area{
    text-align: center;
  }
  .window-tips-bg .content .btn-area input{
    display: inline-block;
    border: none;
    width: 110px;
    height: 40px;
    line-height: 40px;
    color: #fff;
    background: #007AFF;
    font-size: 16px;
    border-radius: 5px;
    margin: 0 10px;
    cursor: pointer;
    outline: none
  }
  .window-tips-bg .content .btn-area input:last-of-type{
    border: 1px solid #007aff;
    color: #007aff;
    background: #fff
  }
  #loading-area{
    display: none;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    z-index: 10;
    color: #fff;
  }
  #loading-area span{
    display: block;
    text-align: center;
    font-size: 24px;
    margin-top: 24px
  }
  #loading-area.active{
    display: block
  }
  #countdown{
    position: absolute;
    top: 10px;
    left: 10px;
    color: #fff;
    font-size: 16px;
  }
</style>
